import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

let app = createApp(App)

app.config.globalProperties.map_Key = 'AIzaSyBw5X5ilF1x09m960w8u2PH2Ep0NpQi_co';

app.use(router).mount('#app')